import { Link } from "react-router-dom";
import React from "react";
import { useQuery } from "@apollo/client";
import { LinearProgress, Grid } from "@mui/material";
import { Button } from "components/haven-design/buttons";
import { RemovalsTracking,
  RemovalsTrackingVariables } from "types/gql-types";
import { REMOVALS_TRACKING } from "pages/waitlist-update/process-removals/query";

type Props = {
  interestListId: string;
}

const ProcessRemovals: React.FC<Props> = ({ interestListId }) => {
  const trackingResults = useQuery<RemovalsTracking, RemovalsTrackingVariables>(REMOVALS_TRACKING, {
    variables: {
      interestListId,
    },
    pollInterval: 2000,
  });

  const removalsAreRunning = !trackingResults.loading &&
    !trackingResults.error && trackingResults.data?.removalsTracking &&
    trackingResults.data.removalsTracking.percentComplete !== 100;

  const removalsComplete = (trackingResults.data?.removalsTracking?.percentComplete ?? 0) === 100;

  if (trackingResults.loading || trackingResults.error) return null;

  const percentComplete = trackingResults.data?.removalsTracking?.percentComplete;
  const totalCount = trackingResults.data?.interestList.scheduledUpdate.removals.totalCount ?? 0;

  return (<>
    <hr/>
    <h3>Process Removals</h3>
    <div className="margin-top-m">
      {!removalsAreRunning && totalCount > 0 &&
      <Link to={`/dash/manager/update/${interestListId}/process/removals`}>
        <Button color="primary" size="S">Process Removals</Button>
      </Link>}
      {removalsAreRunning && (<Grid container spacing={1}>
        <Grid size={{ xs: 12 }}>Sending messages...
          &nbsp;({percentComplete}% sent)</Grid>
        <Grid size={{ xs: 12 }}><LinearProgress variant="determinate" value={percentComplete}/></Grid>
        <Grid size={{ xs: 12 }}></Grid>
        <Grid size={{ xs: 12 }}>You can navigate away from this page while removal
           notices are being sent.</Grid>
      </Grid>)}
      {removalsComplete && totalCount === 0 && (
        <><p>Removal messages sent.</p>
          <p>No remaining removals to process.</p></>
      )}
      {removalsComplete && totalCount > 0 && (
        <>
          <div>&nbsp;</div>
          <p>Some messages failed. Please resend removal messages.</p>
        </>
      )}
    </div></>
  );
};
export default ProcessRemovals;
